import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { actions } from '../../../store/authentication/authRedux';
import { IAllStates } from '../../../store/rootReducer';
import { ErrorToast, SuccessToast } from '../../../utils/toasters';
import { ImpersonateService } from './service';
import LoadingScreen from '../../../shared/components/LoadingScreen';
import { navigateByRole } from '../../../utils/helpers/navigateByRole';

interface ImpersonateParams {
    id: string;
    token: string;
    isAdmin: string;
    adminActiveFirstRoute: string;
    adminActiveSecondRoute: string;
    adminActiveThirdRoute: string;
}

export function Impersonate({ setWhoImpersonate }: any) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { id, token, isAdmin, adminActiveFirstRoute, adminActiveSecondRoute, adminActiveThirdRoute } =
        useParams<keyof ImpersonateParams>();
    const { user } = useSelector((states: IAllStates) => states.auth);
    const { t } = useTranslation();
    const impersonateActiveRoute =
        (adminActiveFirstRoute ? adminActiveFirstRoute : '') +
        (adminActiveSecondRoute ? `/${adminActiveSecondRoute}` : '') +
        (adminActiveThirdRoute ? `/${adminActiveThirdRoute}` : '');
    const isInvalidRoute = adminActiveFirstRoute === 'user' && adminActiveSecondRoute === 'platforms';

    useEffect(() => {
        ImpersonateService.impersonateUser(id, token)
            .then(data => {
                localStorage.setItem('token', JSON.stringify(data.token));
                localStorage.setItem('impersonateActiveRoute', isInvalidRoute ? 'user' : impersonateActiveRoute);
                if (isAdmin !== 'true') {
                    dispatch(actions.setOldUser());
                    dispatch(actions.setOldToken(data.oldToken));
                }
                localStorage.setItem('whoImpersonate', isAdmin === 'true' ? 'admin' : 'agency');
                setWhoImpersonate(isAdmin === 'true' ? 'admin' : 'agency');
                localStorage.setItem('appVersion', data?.userData?.appVersion);
                dispatch(actions.login(data.token));
                dispatch(actions.setUser(data.userData));
                dispatch(actions.setIsVerified({ isVerified: true }));
                SuccessToast(t(`general.toasts.success_impersonated_user`));

                if (isAdmin === 'true') {
                    navigate(navigateByRole(user?.userType));
                }
            })
            .catch(err => ErrorToast(err));
    }, []);

    return (
        <>
            <LoadingScreen />
        </>
    );
}
